import React from 'react';

import { bemCssModules } from '@utils';

import style from './DonutChart.scss';

const cn = bemCssModules(style, 'DonutChart');

export type TCircle = {
  color: string;
  dashArray: string;
  dashOffset: number;
  strokeWidth?: number;
};

const Circle: CustomFC<TCircle> = ({
  color,
  dashArray,
  dashOffset,
  strokeWidth = 2,
  className,
}) => (
  <circle
    className={cn(null, [className])}
    cx="18"
    cy="18"
    r="15.91549430918954"
    fill="transparent"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeDasharray={dashArray}
    strokeDashoffset={dashOffset}
  />
);

export default Circle;
